<template>
    <article :id="`location-${location?.id}`" class="location-card" :class="[classes]">
        <div class="location-preview">
            <NuxtLinkLocale :to="locationRoute" :title="location.title">
                <div class="location-media">
                    <UiImage :src="location.locationPreview[0].webp" :classes="'responsive full'" />
                </div>
            </NuxtLinkLocale>
            <div class="location-title">
                <span class="text" v-html="location.title.split(' ').join('<br>')" />
                <span class="icon">
                    <svg viewBox="0 0 23 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M16.35 15.54L14.34 15.09C14.76 11.97 16.56 9.36 18.9 8.64H0V6.9H18.9C16.56 6.18 14.76 3.57 14.34 0.450001L16.35 0C16.62 4.35 19.29 6.6 22.5 6.9V8.64C19.29 8.94 16.62 11.19 16.35 15.54Z"
                            fill="white"
                        />
                    </svg>
                </span>
            </div>
        </div>
    </article>
</template>

<script setup lang="ts">
import type { CmsItem } from '~/types/cms';

const props = defineProps({
    location: {
        type: Object,
        default: () => ({})
    },
    classes: {
        type: Array,
        default: () => []
    }
});

const locationRoute = computed(() => useLocationRouteTarget(props.location as CmsItem));
</script>
